<template>
  <div class="box">
    <div class="addLanguages">
    <van-form @submit="onSubmit">
        <van-cell-group>
          <!-- <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.empno" placeholder="请输入工号" label="工号"/> -->
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.language" placeholder="请输入语言" label="语言"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.grade" placeholder="请输入等级" label="等级"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.certificate" placeholder="请输入证书" label="证书"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.certorg" placeholder="请输入附件" label="附件"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" v-model="baseinfo.getdate" placeholder="请输入证书获取日期" label="证书获取日期"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" label-width="140" v-model="baseinfo.degatteach" placeholder="请输入学位证书附件" label="学位证书附件(图片)"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.remark" placeholder="请输入备注" label="备注"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.files" placeholder="请输入附件" label="附件(图片)"/>
        </van-cell-group>
        <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn">确认</van-button>
        </div>
    </van-form>
    <div class="footer">
      <van-button round block class="btnClo" @click="toInfo">取消</van-button>
    </div>
  </div>
  </div>
</template>

<script>
import api from '@/apis'
import moment from 'moment'
export default {
  name: "addLanguages",
  data(){
    return {
      baseinfo:{
        empno: "",//员工工号
        language: "", //语言
        grade: "", //等级
        certificate: "", //证书
        certorg: "",// 附件
        getdate: "", //证书获取日期
        remark: "", //备注
        files: "", //附件（图片）
      }
    }
  },
  methods: {
    // 提交表单
    onSubmit(){
      let obj = {
        ...this.baseinfo,
        getdate:moment(this.baseinfo.getdate).format('YYYY-MM-DD'),
        table:'euBglanguagesList',
        saveType:'1',
        empid:this.$store.state.userInfo.empID,
        empno:this.$store.state.userInfo.empNo
      }
      api.setSaveEmpInfo(obj).then(()=>{
        this.$toast('添加成功');
        this.$router.push({
        path:'/mobile/info',
        query:{
          type:'add'
        }
        })
      })
    },
    // 跳转
    toInfo(){
      this.$router.push({
        path:'/mobile/info',
        query:{
          type:'no'
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .addLanguages {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .addLanguages {
    width: 276px * $zoom;
  }
}
.box{
  display: flex;
  justify-content: center;
}
.addLanguages {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.fromBox{
    height: 90vh;
}
.btnBox{
    width: 50%;
    position: absolute;
    bottom: 20px * $zoom;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px * $zoom 20px * $zoom;
    margin-left: 50%;
}
.btn {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
}
.footer{
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  justify-content: flex-end;
  padding: 10px * $zoom 20px * $zoom;
}
.btnClo{
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
  border: none;
}
</style>
